import script from "./InstructionUspacyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionUspacyPage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionUspacyPage.vue?vue&type=style&index=0&id=12e9c5c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12e9c5c8"]])

export default __exports__